<template>
    <div class="product">
        <div class="product-banner">
            <div class="banner-content">
                <div class="left">
                <div><span>专业</span>的软件公司</div>
                <div>我们让产品更有价值</div>
                <div>专业/高效/价值/产品</div>
                <!-- <div>了解更多</div> -->
                </div>
            </div>
        </div>
        <div class="product-content">
            <div class="product-wrapper all-product">
                <div>
                    <img :src="sycp" alt="">
                </div>
                <!-- <div>客户考虑的因素，那么最好提供多的图片，而且不同图片名称也有利于SEO的目的</div> -->
                <div class="list">
                    <div class="item" v-for="(item,index) in arr1" :key="index">
                        <div class="icon">
                            <img :src="cp" alt="">
                        </div>
                        <div>{{item.title}}</div>
                        <div class="intro" v-html="item.intro"></div>
                    </div>
                </div>
            </div>
            <div class="product-intro">
                <div class="intro">
                    <div class="intro-text">
                        <div>{{curProduct.title}}</div>
                        <div>产品简介</div>
                        <div v-html="curProduct.intro"></div>
                        <div class="btn">
                            <el-button type="warning" @click="next">下一个</el-button>
                        </div>
                        <img :src="zz" alt="">
                    </div>
                </div>
            </div>
            <div class="product-wrapper my-product">
                <div>我们的产品</div>
                <div>针对异地互动教学场景设计的教学工具</div>
                <div class="my-product-list">
                    <div class="my-product-item" @click="toDetail(item.name)" v-for="(item,index) in arr3" :key="index">
                        <div class="icon">
                            <img :src="wd" alt="">
                        </div>
                        <div>
                            {{item.title}}
                        </div>
                        <div>
                            {{item.intro}}
                        </div>
                        <div>
                            <img :src="jt" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            cp: require('@/assets/icon_cp@2x.png'),
            sycp: require('@/assets/sycp@2x.png'),
            zz: require('@/assets/img_zz@2x.png'),
            wd: require('@/assets/icon_wd@2x.png'),
            jt: require('@/assets/icon_jt@2x.png'),
            arr1: [
                {
                    title: '乐分享题库系统 · 网络客户端版',
                    intro: '适用于所有行业、全部学科快速建立专业题库！'
                },
                {
                    title: '乐分享题库系统 · 网页版',
                    intro: '软件支持功能定制，可以根据需求定制个性化版本！'
                },
                {
                    title: '乐分享在线考试',
                    intro: 'PC、移动端、微信小程序等均可进行考试'
                },
            ],
            curIndex: 0,
            arr2: [
                {
                    title: '乐分享题库系统 · 网络客户端版',
                    intro: '适用于所有行业、全部学科快速建立专业题库！<br>支持Word所支持的全部格式。<br>独创把Word嵌入到软件中的功能，在软件中直接使用Word编辑题目，十分方便。<br>提供多个批量入库的Word模板，可以把多种复杂类型的试卷快速批量入库'
                },
                {
                    title: 'Word批量处理大师',
                    intro: '试用版一次最多处理6个文件<br>注册后，推荐一次处理不超出1万个Word文件几十个修改需求，一次就可以完成。'
                },
                {
                    title: 'PPT批量处理大师',
                    intro: '一次批量处理最多3万文件几十个功能自由组合<br>一次添加多个处理任务<br>自由升级，无限制'
                },
                {
                    title: '乐分享题库系统 · 网页版',
                    intro: '适用于所有行业、全部学科快速建立专业题库！<br>支持Word所支持的全部格式。<br>软件支持功能定制，可以根据需求定制个性化版本！<br>乐分享题库集上传、编辑、组卷、下载、考试、成绩分析等所有功能于一身'
                },
                {
                    title: '乐分享在线考试',
                    intro: '跨平台、多方位的考试系统<br>PC、移动端、微信小程序等均可进行考试<br>防作弊'
                },
            ],
            arr3: [
                {
                    title: '乐分享题库系统 · 网络客户端版',
                    intro: '适用于所有行业、全部学科快速建立专业题库！',
                    name: 'CSDetail'
                },
                {
                    title: '乐分享题库系统 · 网页版',
                    intro: '软件支持功能定制，可以根据需求定制个性化版本！',
                    name: 'Tiku'
                },
                {
                    title: '乐分享在线考试',
                    intro: 'PC、移动端、微信小程序等均可进行在线考试',
                    name: 'OnlineDetail'
                },
                {
                    title: 'Word批量处理大师',
                    intro: '一次处理不超出1万个Word文件几十个修改需求',
                    name: 'Word'
                },
                {
                    title: 'PPT批量处理大师',
                    intro: '一次批量处理最多3万文件几十个功能自由组合',
                    name: 'Ppt'
                },
            ]
        }
    },
    computed: {
        curProduct(){
            return this.arr2[this.curIndex]
        }
    },
    methods: {
        next(){
            this.curIndex++;
            if(this.curIndex > this.arr2.length - 1){
                this.curIndex = 0;
            }
        },
        toDetail(name){
            this.$router.push({
                name: name
            })
        }
    },
    created(){
        
    }
}
</script>
<style lang="less">
    .product{
        .product-banner{
            height: 730px;
            background: #198AF7 url('../assets/img_sycp@2x.png') no-repeat center center;
            .banner-content{
                width: 1200px;
                position: relative;
                margin: 0 auto;
                .left{
                    position: absolute;
                    top: 230px;
                    right: 0;
                    color: #fff;
                    >div{
                        &:nth-of-type(1){
                            font-size: 36px;
                            span{
                                color: #FFA95E;
                            }
                        }
                        &:nth-of-type(2){
                            font-size: 50px;
                            margin: 8px 0;
                        }
                        &:nth-of-type(3){
                            font-size: 24px;
                        }
                        &:nth-of-type(4){
                            text-align: center;
                            font-size: 20px;
                            width:150px;
                            height:50px;
                            line-height: 50px;
                            border:1px solid rgba(255,255,255,1);
                            border-radius:25px;
                            margin-top: 20px;
                            cursor: pointer;
                            &:hover{
                                background-color: #f88927;
                                border-color: #f88927;
                            }
                        }
                    }
                }
            }
        }
        .product-content{
            .product-wrapper{
                width: 1200px;
                margin: 0 auto;
                .list{
                    display: flex;
                    margin-top: 30px;
                    justify-content: center;
                    .item{
                        width: 300px;
                        height: 402px;
                        margin-right: 20px;
                        justify-content: center;
                        box-sizing: border-box;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        cursor: pointer;
                        padding: 20px 0;
                        .intro{
                            text-align: left;
                        }
                        &:nth-last-of-type(1){
                            margin-right: 0;
                        }
                        &:hover{
                            transition: all 0.6s;
                            transform: scale(1.04);
                            border: 1px solid #32AEFB;
                            box-shadow:0px 4px 16px 0px rgba(158,158,158,0.4);
                        }
                        div{
                            &:nth-of-type(2){
                                color:#F88927;
                                font-size:30px;
                                margin-top:47px;
                                margin-bottom:10px;
                            }
                            &:nth-of-type(3){
                                font-size:20px;
                                width:267px;
                                margin:0 auto;
                            }
                        }
                        .icon{
                            img{
                                width: 107px;
                                height: 121px;
                            }
                        }
                    }
                }
            }
            .all-product{
                text-align: center;
                padding: 30px 0;
                height: 600px;
                >div{
                    &:nth-of-type(1){
                        font-size:18px;
                        text-align:left;
                        margin-left:360px;
                        margin-bottom:25px;
                    }
                    &:nth-of-type(2){
                        color:#8F8F8F;
                        font-size:20px;
                    }
                }
            }
            .product-intro{
                background-color: #F0FBFF;
                .intro{
                    width: 1200px;
                    margin: 0 auto;
                    padding-top: 120px;
                    padding-bottom: 120px;
                    box-sizing: border-box;
                    .intro-text{
                        width: 764px;
                        height: 511px;
                        position: relative;
                        background-color: #fff;
                        box-sizing: border-box;
                        padding: 30px 60px 30px 30px;
                        .btn{
                            position: absolute;
                            bottom: 70px;
                            left: 30px;
                        }
                        div{
                            &:nth-of-type(1){
                                font-size: 30px;
                                
                            }
                            &:nth-of-type(2){
                                font-size: 18px;
                                margin: 40px 0;

                            }
                            &:nth-of-type(3){
                                color: #8F8F8F;
                                font-size: 18px;
                                margin-bottom: 40px;
                            }
                        }
                    }
                    img{
                        position: absolute;
                        left: 721px;
                        top: 50px;
                    }
                }
            }
            .my-product{
                padding: 30px 0;
                >div{
                    &:nth-of-type(1){
                        color: #F88927;
                        font-size: 20px;
                    }
                    &:nth-of-type(2){
                        font-size: 30px;
                        margin: 20px 0;
                    }
                }
                .my-product-list{
                    display: flex;
                    flex-wrap: wrap;
                    // justify-content: space-between;
                    box-sizing: border-box;
                    padding: 0 30px;
                    margin-top: 50px;
                    .my-product-item{
                        width: 265px;
                        height: 370px;
                        margin-right: 172px;
                        margin-bottom: 79px;
                        padding: 32px;
                        box-shadow:0px 4px 16px 0px rgba(178, 178, 178, 0.35);
                        box-sizing: border-box;
                        display: flex;
                        position: relative;
                        flex-direction: column;
                        justify-content: center;
                        text-align: center;
                        cursor: pointer;
                        &:nth-of-type(3n){
                            margin-right: 0;
                        }
                        &:hover{
                            transition: all 0.6s;
                            transform: scale(1.04);
                            border: 1px solid #32AEFB;
                            box-shadow:0px 4px 16px 0px rgba(158,158,158,0.4);
                        }
                        .icon{
                            img{
                                width: 76px;
                                height: 84px;
                            }
                        }
                        >div{
                            &:nth-of-type(2){
                                font-size: 24px;
                                margin: 26px 0;
                            }
                            &:nth-of-type(3){
                                font-size: 20px;
                                color: #8F8F8F;
                                margin-bottom: 30px;
                                width: 205px;
                            }
                        }
                    }
                }
            }
        }
    }
</style>